import { render, staticRenderFns } from "./featuredListing.vue?vue&type=template&id=81850822&"
import script from "./featuredListing.vue?vue&type=script&lang=ts&"
export * from "./featuredListing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports